export default function getLinkId(source, target) {
  return `${source},${target}`;
}
